// Mobile filter drawer for the category/archive page. Desktop shows the same
// markup as a static sticky sidebar (see _category-page.scss) — this only
// toggles the mobile overlay state.

function init() {
    const page = document.getElementById('category-page');
    if (!page) return;

    const sidebar = page.querySelector('[data-category-filters-drawer]');
    const backdrop = document.querySelector('.category-page__filter-drawer-backdrop');
    const openBtn = page.querySelector('[data-category-filters-open]');
    const closeBtns = page.querySelectorAll('[data-category-filters-close]');

    function open() {
        sidebar.classList.add('category-page__sidebar--active');
        if (backdrop) backdrop.classList.add('category-page__filter-drawer-backdrop--active');
        document.body.classList.add('no-scroll');
    }
    function close() {
        sidebar.classList.remove('category-page__sidebar--active');
        if (backdrop) backdrop.classList.remove('category-page__filter-drawer-backdrop--active');
        document.body.classList.remove('no-scroll');
    }

    if (openBtn) openBtn.addEventListener('click', open);
    closeBtns.forEach((btn) => btn.addEventListener('click', close));
    if (backdrop) backdrop.addEventListener('click', close);
}

export default { init };
